import { FormEnginePlugin } from '@form-engine/core-application';
import Datasource, { apiName } from './datasources/jwt-datasource';

declare module '@form-engine/core-application/types/form' {
    interface DatasourceDefinitionSubType {
        [apiName]: {
            jwtSource?: string;
            jwtOutput?: string;
        };
    }
}

export default {
    datasources: {
        [Datasource.apiName]: Datasource,
    },
} as FormEnginePlugin;
